import React from "react";
import "../Leadership/LeadershipFounderMessage.css";
import founderPhoto from "../../Assets/career/cfound.png";
import founderPhoto1 from "../../Assets/career/cfound1.png";
import vcnrLogo from "../../Assets/vcnr-logo-white.png";

const CareerFounder = () => {
  return (
    <section className="Leaderfounder-section">
      <div className="Leaderfounder-container">
        <div className="Leaderfounder-left">
          <div className="Leaderfounder-image-wrapper">
            <img src={founderPhoto} alt="Founder" className="Leaderfounder-image" />
            <img src={founderPhoto1} alt="Founder1" className="Leaderfounder-image1" />
          </div>
        </div>
        <div className="Leaderfounder-right">
          <h2 className="Leaderfounder-heading">Building a Culture <br />of Purpose, <br />Powered by People</h2>
          <img src={vcnrLogo} alt="VCNR Logo" className="Leadervcnr-logo" />
          <p className="Leaderfounder-text">
At VCNR, we believe that meaningful work starts with a meaningful workplace. Our culture is collaborative and inclusive. You can get hired immediately only if you have the required focus in your field. Whether you’re an engineer, a healthcare professional, or a creative thinker, you’ll find space to innovate and contribute to something bigger.
         </p>
          <p className="Leaderfounder-text">
We celebrate diversity and believe that a strong team thrives on different perspectives. From wellness programs and learning pathways to mentorship circles and open-door leadership, our people are empowered to lead from where they stand.          </p>
          <h4 style={{marginBottom:"1rem"}}>At VCNR, we don’t just grow businesses
we grow people</h4>
          <button className="explore-btn">Read Our Story in Unstoppable</button>
        </div>
      </div>
    </section>
  );
};

export default CareerFounder;
